<template>
    <div>
        <el-autocomplete
            v-if="hasQueues"
            v-model="queue"
            :fetch-suggestions="querySearch"
            placeholder="Search Queue's"
            :clearable="true"
            @clear="handleClear()"
            @select="handleSelect"
            size="small"
        >
            <div slot="append">
                <el-tooltip
                    :content="'You\'ll be redirected to the ringgroup page to create a new one.'"
                    effect="dark"
                    :open-delay="300"
                    placement="top">
                    <router-link to="/ringgroups">
                        <span class="text-success"><font-awesome-icon :icon="['fal','plus']"></font-awesome-icon></span>
                    </router-link>
                </el-tooltip>
            </div>
        </el-autocomplete>
        <span v-if="!hasQueues">You have no Queue's, you can create one <router-link
            to="/queues">here</router-link></span>
    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";

    export default {
        name: "QueueSelector",
        props: {
            initialQueue: {
                type: String,
                default: '',
            },
        },
        computed: {
            ...mapFields('queue', ['queues', 'isLoading']),
            hasQueues: function () {
                if (this.$store.getters['queue/isLoading']) {
                    return false;
                }
                return this.queues.length > 0;
            },
        },
        data() {
            return {
                queue: null,
            }
        },
        methods: {
            querySearch(queryString, cb) {
                let queues = this.queues;
                let results = queryString ? queues.filter(this.createFilter(queryString)).map(s => {
                    return {id: s.id, value: s.name}
                }) : queues.map(s => {
                    return {id: s.id, value: s.name}
                });
                cb(results);

            },
            createFilter(queryString) {
                return (queue) => {
                    let nameExists = queue.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || queue.id.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
                    return (nameExists);
                };
            }
            ,
            handleSelect(queue) {
                let name = queue.id;
                this.$emit('update', {name});
            }
            ,
            handleClear() {
                this.$emit('update', {});
            },
            setQueue() {
                this.queue = this.queues.filter(q => q.id === this.initialQueue)[0].name
            }
        },
        mounted() {
            if (this.$store.getters['queue/needUpdate']) {
                this.$store.dispatch('queue/load').then(() => this.setQueue());
            } else {
                this.setQueue();
            }
        }
    }
</script>

<style scoped>

</style>
